<!-- template for the modal component -->
<template>
    <label v-if="showTooltip" :for="forTag">
        {{ label }} <tooltip-view :label="label" :show-question-mark="showQuestionMark" :popper-content="popperContent" referenceElement="open me" />
    </label>
    <label v-else-if="label" v-once :for="forTag">
        {{ label }} <tooltip v-if="tooltipLink || tooltipText" :tooltip-link="tooltipLink" :tooltip-text="tooltipText" :unique-id="uniqueId" :show-tooltip-loader="showTooltipLoader" />
    </label>
    <span v-else>
        <tooltip v-if="tooltipLink || tooltipText" :tooltip-link="tooltipLink" :tooltip-text="tooltipText" :tooltip-class="tooltipClass" :unique-id="uniqueId" :show-tooltip-loader="showTooltipLoader" />
    </span>
</template>
<script>
    import Tooltip from './tooltip.vue';
    import TooltipView from './tooltip-view.vue';

    export default {
        props: {
            label: {
                type: String,
                default: '',
            },
            span: {
                type: String,
                default: '',
            },
            tooltipLink: {
                type: String,
                default: '',
            },
            tooltipClass: {
                default: 'lt-icons lt4-QuestionOutline calc-question a11y-modal-trigger',
            },
            tooltipText: {
                type: String,
                default: '',
            },
            showTooltip: {
                default: false,
            },
            showQuestionMark: {
                default: '',
            },
            popperContent: {
                default: '',
            },
            forTag: {
                default: '',
            },
            uniqueId: {
                default: '',
            },
            showTooltipLoader: {
                default: false,
            },
        },
        components: {
            Tooltip,
            TooltipView,
        },
    };
</script>

<style scoped lang="scss">
@import "../../../assets/styles/v2/variables";

.calc-filter {
    label {
        color: #444;
        font-size: 15px;
        font-weight: 400;
        text-align: left;
        display: block;

        @media #{$vs-down} {
            font-size: 14px;
        }
    }
}

.gray-bg {
    .calc-filter label {
        font-family: 'Source Sans Pro', sans-serif;
        color: #787878;
        font-weight: bold;
        font-size: 17px;
        margin-bottom: 15px;
    }
}
</style>
